import React from "react";
import {Box,} from "@mui/material";

export default function FlatBar3({values, colors, textColor, classe}) {
    const [barData, setBarData] = React.useState(undefined);
    const [nb, setNb] = React.useState(0);
    React.useEffect(() => {
        if (values && values.length > 0) {
            let res = {}
            values.forEach(value => {
                if (!res[value[classe]]) {
                    res[value[classe]] = 0;
                }
                res[value[classe]]++;
            })
            setBarData(res)
        }
    }, [values])


    function getColor(label) {
        if (label.toLowerCase() === "insuffisante") {
            return "#f94144";
        } else if (label.toLowerCase() === "légère") {
            return "#43aa8b";
        } else if (label.toLowerCase() === "très lourde") {
            return "#f94144";
        } else if (label.toLowerCase() === "lourde") {
            return "#d57777";
        } else if (label.toLowerCase() === "moyenne") {
            return "#f9844a";
        } else if (label.toLowerCase() === "bonne") {
            return "#90be6d";
        } else if (label.toLowerCase() === "très bonne") {
            return "#43aa8b";
        }
        return "#000000";
    }

    return (<Box sx={{width: "95%", display: "flex", m: 1}}>
            {barData && Object.keys(barData).map((key, index) => {
                return (
                    <Box key={index}
                         sx={{
                             width: barData[key] / values.length * 100 + "%",
                             backgroundColor: getColor(key),
                             display: "flex",
                             flexDirection: "column",
                             alignItems: "center",
                             justifyContent: "center",
                             color: textColor ? textColor : "black",
                             borderTopRightRadius: index + 1 === Object.keys(barData).length ? 10 : 0,
                             borderBottomRightRadius: index + 1 === Object.keys(barData).length ? 10 : 0,
                             borderTopLeftRadius: index + 1 === 1 ? 10 : 0,
                             borderBottomLeftRadius: index + 1 === 1 ? 10 : 0,
                             height: 50,
                             fontSize: "0.8em",
                             wordWrap: "break-word"

                         }}>
                        {barData[key]} {key}
                    </Box>
                )
            })}
        </Box>
    )
}
